import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import Partner from './partnerList.component'
import ViewPartner from './partnerView.component'

function PartnerBase() {
    const { isLoggedIn } = useSelector(state => state.auth);
    if (!isLoggedIn) {
        return <Navigate to="/login/" />;
    }

    return (
        <>
            <div className="col-md-12">
                <Routes>
                    <Route path="/" element={<Partner />} />
                    <Route path="/:id/" element={<ViewPartner />} />
                </Routes>
            </div>
        </>
    );


}

export default PartnerBase;